export default __webpack_public_path__ + "static/media/Course-Map.c9dba6e2.png";